function initCursorCoordinates() {
  function updateFromEvent(event) {
    const x = String(Math.round(event.pageX));
    const y = String(Math.round(event.pageY));
    document.querySelectorAll('.x-coordinate [data-coordinates-x]').forEach((el) => {
      el.textContent = x;
    });
    document.querySelectorAll('.y-coordinate [data-coordinates-y]').forEach((el) => {
      el.textContent = y;
    });
  }

  const hasAny =
    document.querySelector('.x-coordinate [data-coordinates-x]') ||
    document.querySelector('.y-coordinate [data-coordinates-y]');
  if (!hasAny) return;

  document.addEventListener('mousemove', updateFromEvent);
}

/** Stagger removal of `.hero-text` loading-* classes (see `snippets/hero-text.liquid`). */
const heroTextLoadingScheduled = new WeakSet();

function initHeroTextLoadingSequence() {
  const START_MS = 200;
  const STEP_MS = 400;
  document.querySelectorAll('.hero-text.loading-1').forEach((el) => {
    if (heroTextLoadingScheduled.has(el)) return;
    heroTextLoadingScheduled.add(el);
    for (let i = 1; i <= 4; i += 1) {
      setTimeout(() => {
        el.classList.remove(`loading-${i}`);
      }, START_MS + STEP_MS * (i - 1));
    }
  });
}

function initOnReady(init) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

// Initialize Cursor Coordinates
initOnReady(() => {
  initCursorCoordinates();
  initHeroTextLoadingSequence();
});

document.addEventListener('shopify:section:load', () => {
  initHeroTextLoadingSequence();
});




import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

/** Draco-compressed GLBs need WASM decoders (must match Three’s expected layout). */
const DRACO_DECODER_BASE = 'https://www.gstatic.com/draco/versioned/decoders/1.5.6/';

/**
 * `null` = all lights on (normal).
 * Set to `'hemi'`, `'ambient'`, `'key'`, `'fill'`, or `'back'` to enable only that light (debug).
 */
const LIGHT_ISOLATE = null;

/** Valid ids for `LIGHT_ISOLATE` and the light-debug isolate control. */
const LIGHT_DEBUG_IDS = ['hemi', 'ambient', 'key', 'fill', 'back'];

/** Drag sensitivity (radians per pixel, scaled by canvas height). */
const ORBIT_ROTATE_SPEED = 0.72;
/** Max rotation applied in one frame (rad) — caps flick / peak velocity. */
const MAX_SPIN_PER_FRAME = 0.1;
/**
 * Inertia decay per frame for model spin (multiply spin by 1 - this each frame).
 * Lower = longer coast / more “float” after a flick; independent of OrbitControls zoom damping.
 */
const SPIN_DAMPING_FACTOR = 0.035;

/**
 * After centering the GLB, shift it up by `maxDim * this` (world units).
 * Tweak for framing in the canvas; set to `0` for no offset.
 */
const MODEL_VERTICAL_OFFSET_RATIO = 0;

/** Theme slider values (hotspot position) are multiplied by this in model space. */
const HOTSPOT_POSITION_SCALE = 0.19;
/** Hotspot `position[0]` / `[1]` (X/Y) theme units from debug sliders (Z uses `HOTSPOT_POSITION_Z_MAX`). */
const HOTSPOT_POSITION_XY_MAX = 1;
const HOTSPOT_POSITION_Z_MAX = 0.5;

/** Theme units for `focus_pan_x` / `focus_pan_y` (sliders + JSON); clamped to ±this before scaling. */
const FOCUS_PAN_THEME_MAX = 2;
/** Theme focus pan X/Y (±`FOCUS_PAN_THEME_MAX` theme units) × maxDim × this → `modelRoot.position` offset when focused / in tuner (Y adds to `modelYOffset`). */
const FOCUS_PAN_X_SCALE = 0.15;
const FOCUS_PAN_Y_SCALE = 0.15;

/** Flip to `false` in code while debugging (no theme editor); skips billboard hotspot sprites. */
const ENABLE_HOTSPOTS = true;
/**
 * When `true`, hotspot titles render in `[data-webgl-markers]` (projected to match 3D each frame);
 * canvas sprites show the icon only. Requires `custom-webgl` section markup with `data-webgl-markers`.
 */
const HOTSPOT_HTML_LABELS = true;

/**
 * Match CSS “below 1000px” (`max-width: 999px`): larger hotspot billboards, no drag/zoom/scroll-intro spin.
 */
const WEBGL_DESKTOP_INTERACTION_MIN_WIDTH = 1000;
/** Sprite scale multiplier for hotspots when viewport is narrower than `WEBGL_DESKTOP_INTERACTION_MIN_WIDTH`. */
const WEBGL_HOTSPOT_MOBILE_SCALE = 2;

function isWebglDesktopViewport() {
  return typeof window !== 'undefined' && window.innerWidth >= WEBGL_DESKTOP_INTERACTION_MIN_WIDTH;
}

/** Canvas draw size for the icon (circle + plus); not the same as world scale (see hotspot loop). */
const HOTSPOT_ICON_SCREEN_PX = 52;
/** Max label width in CSS pixels (title texture). */
const HOTSPOT_TITLE_MAX_W = 280;
/**
 * `Sprite.scale` is in **world units** (even with `sizeAttenuation: false`), not layout pixels.
 * We map composite texture width (~this many px) to `HOTSPOT_TARGET_WORLD_FACTOR * maxDim` so billboards
 * stay near the mesh — otherwise ~300 world units vs ~2 unit models breaks clipping (grey view).
 */
const HOTSPOT_DESIGN_REF_PX = 280;
const HOTSPOT_TARGET_WORLD_FACTOR = 0.45;

/**
 * When `true`, hotspot billboards participate in depth testing so other parts of the mesh
 * can occlude them (same “flat sticker” look, but they sit in 3D space visually).
 * When `false`, they ignore depth and always render on top (old behavior).
 * Keep `depthWrite` off on the material so semi-transparent edges don’t poison the depth buffer.
 */
const HOTSPOT_OCCLUDE_BY_DEPTH = true;

/**
 * Scroll intro: world Y — first −4°, then forward 364° with strong ease-out (−4 + 364 = 360° → rest pose).
 * Total duration = phase1 + phase2 (interaction stays locked until complete).
 */
const SCROLL_INTRO_NEG_DEG = 4;
const SCROLL_INTRO_FWD_DEG = 364;
/** Short lead-in for the −4° move. */
const SCROLL_INTRO_PHASE1_MS = 320;
/** Main sweep (364°) — most time here so ease-out reads clearly. */
const SCROLL_INTRO_PHASE2_MS = 1680;
/** Phase 1 (−4°): ease-in-out on the small move. */
const SCROLL_INTRO_PHASE1_EASE_POWER = 2;
/** Phase 2 (364°): ease-out only — higher = stronger deceleration at the end. */
const SCROLL_INTRO_PHASE2_EASE_OUT_POWER = 7;
/**
 * End intro + unlock as soon as orientation is within this of the rest pose (degrees).
 * Strong ease-out packs most rotation into the early part of phase 2; without this, the model
 * looks finished long before `phase2Ms` elapses.
 */
const SCROLL_INTRO_END_EPS_DEG = 1;
/**
 * Master switch for scroll-triggered intro. Theme “Scroll intro animation” must also be on.
 * Set to `false` to disable regardless of theme.
 */
const ENABLE_SCROLL_INTRO_ANIMATION = true;

/** Click hotspot: slerp model + camera to match focus pose JSON (same math as pose tuner). */
const HOTSPOT_FOCUS_DURATION_MS = 900;
/**
 * After GLB load: camera distance = `maxDim * this` from orbit target (larger = more zoomed out).
 * Kept comfortably above the mesh bounding sphere so the default view does not feel “inside” the model.
 */
const INITIAL_CAMERA_FIT_MULTIPLIER = 1.52;
/**
 * Rotation starts after this fraction of the focus timeline (0–1) so the camera dollies first;
 * avoids the mesh swinging through the camera mid-slerp.
 */
const HOTSPOT_FOCUS_ROT_DELAY = 0.18;
/** When a hotspot panel is open, other billboard sprites lerp toward this opacity (0 = hidden). */
const HOTSPOT_DIM_OPACITY = 0;
/** Per-frame opacity lerp (smooth fade vs instant). */
const HOTSPOT_OPACITY_LERP = 0.18;
/**
 * OrbitControls `minDistance` is camera→`controls.target`. Loader raises it to ~`boundSphere.radius`
 * when zoom is on so the camera cannot sit inside the hull while the target is the **orbit center**.
 * Hotspot focus moves the target to a **surface point**, so the same floor would be huge relative to
 * the real camera→hotspot gap and `controls.update()` shoves the camera outward every frame.
 */
const HOTSPOT_FOCUS_CONTROLS_MIN_DISTANCE = 0.001;

/** Focus camera distance (theme + tuner): dolly along view axis; must match section `focus_zoom` range. */
const FOCUS_ZOOM_MIN = 0;
const FOCUS_ZOOM_MAX = 0.5;
const FOCUS_ZOOM_STEP = 0.1;
const FOCUS_ZOOM_DEFAULT = 0.3;
/** `applyTunerPose`: distance multiplier uses `fz / this` (baseline framing when fz equals this). */
const FOCUS_ZOOM_DIST_REF = 0.4;
/**
 * Floor for camera distance along the view axis in the tuner. At zoom 0 the raw distance is 0, so the
 * camera sits on `orbitTarget` and `lookAt(orbitTarget)` is degenerate (unstable “top-down” flip).
 */
const TUNER_FOCUS_MIN_DIST_FACTOR = 0.12;

function clampFocusZoom(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return FOCUS_ZOOM_DEFAULT;
  return Math.max(FOCUS_ZOOM_MIN, Math.min(FOCUS_ZOOM_MAX, v));
}

function roundFocusZoomStep(n) {
  const v = clampFocusZoom(n);
  const snapped = Math.round(v / FOCUS_ZOOM_STEP) * FOCUS_ZOOM_STEP;
  return parseFloat(snapped.toFixed(1));
}

/**
 * Merge optional JSON textarea values from Hotspot blocks (tuner “Copy position” / “Copy rotation…”).
 * @param {Record<string, unknown>} raw
 */
function normalizeHotspotFromTheme(raw) {
  const out = {
    id: raw.id,
    title: raw.title,
    body: raw.body ?? '',
    position: Array.isArray(raw.position) ? [...raw.position] : [0, 0.2, 0.5],
    useCustomRotation: raw.useCustomRotation === true,
    rotationDeg: Array.isArray(raw.rotationDeg) ? [...raw.rotationDeg] : [0, 0, 0],
    focusZoomAlong: Number(raw.focusZoomAlong),
    focusPanX: Number(raw.focusPanX),
    focusPanY: Number(raw.focusPanY),
  };
  if (!Number.isFinite(out.focusZoomAlong)) out.focusZoomAlong = FOCUS_ZOOM_DEFAULT;
  if (!Number.isFinite(out.focusPanX)) out.focusPanX = 0;
  if (!Number.isFinite(out.focusPanY)) out.focusPanY = 0;

  const posStr = raw.positionJson;
  if (typeof posStr === 'string' && posStr.trim()) {
    try {
      const pj = JSON.parse(posStr.trim());
      if (Array.isArray(pj) && pj.length >= 3) {
        out.position = [Number(pj[0]), Number(pj[1]), Number(pj[2])];
      } else if (pj && typeof pj === 'object') {
        if ('pos_x' in pj) out.position[0] = Number(pj.pos_x);
        if ('pos_y' in pj) out.position[1] = Number(pj.pos_y);
        if ('pos_z' in pj) out.position[2] = Number(pj.pos_z);
      }
    } catch {
      /* ignore invalid JSON */
    }
  }

  const poseStr = raw.focusPoseJson;
  if (typeof poseStr === 'string' && poseStr.trim()) {
    try {
      const fj = JSON.parse(poseStr.trim());
      if (fj && typeof fj === 'object') {
        if ('use_custom_rotation' in fj) out.useCustomRotation = !!fj.use_custom_rotation;
        if ('rotation_x' in fj) out.rotationDeg[0] = Number(fj.rotation_x);
        if ('rotation_y' in fj) out.rotationDeg[1] = Number(fj.rotation_y);
        if ('rotation_z' in fj) out.rotationDeg[2] = Number(fj.rotation_z);
        if ('focus_zoom' in fj) out.focusZoomAlong = Number(fj.focus_zoom);
        if ('focus_pan_x' in fj) out.focusPanX = Number(fj.focus_pan_x);
        if ('focus_pan_y' in fj) out.focusPanY = Number(fj.focus_pan_y);
      }
    } catch {
      /* ignore invalid JSON */
    }
  }

  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  out.position[0] = clamp(Number(out.position[0]) || 0, -HOTSPOT_POSITION_XY_MAX, HOTSPOT_POSITION_XY_MAX);
  out.position[1] = clamp(Number(out.position[1]) || 0, -HOTSPOT_POSITION_XY_MAX, HOTSPOT_POSITION_XY_MAX);
  out.position[2] = clamp(Number(out.position[2]) || 0, -HOTSPOT_POSITION_Z_MAX, HOTSPOT_POSITION_Z_MAX);
  {
    const rawZ = Number(out.focusZoomAlong);
    out.focusZoomAlong = clampFocusZoom(Number.isFinite(rawZ) ? rawZ : FOCUS_ZOOM_DEFAULT);
  }
  out.focusPanX = clamp(Number(out.focusPanX) || 0, -FOCUS_PAN_THEME_MAX, FOCUS_PAN_THEME_MAX);
  out.focusPanY = clamp(Number(out.focusPanY) || 0, -FOCUS_PAN_THEME_MAX, FOCUS_PAN_THEME_MAX);
  if (!Number.isFinite(out.rotationDeg[0])) out.rotationDeg[0] = 0;
  if (!Number.isFinite(out.rotationDeg[1])) out.rotationDeg[1] = 0;
  if (!Number.isFinite(out.rotationDeg[2])) out.rotationDeg[2] = 0;

  return out;
}

/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {string} text
 * @param {number} maxWidth
 */
function ellipsizeText(ctx, text, maxWidth) {
  if (!text || ctx.measureText(text).width <= maxWidth) return text;
  const ellipsis = '…';
  let lo = 0;
  let hi = text.length;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    const s = text.slice(0, mid) + ellipsis;
    if (ctx.measureText(s).width <= maxWidth) lo = mid;
    else hi = mid - 1;
  }
  return text.slice(0, lo) + ellipsis;
}

/**
 * One billboard texture: optional title pill + solid circle with contrasting plus.
 * Default fill is orange; pass `options` for the positional tuner dummy (blue).
 * Anchor is the center of the circle (for placement on the model).
 *
 * @param {string} title
 * @param {number} dpr
 * @param {{ circleFill?: string; plusStroke?: string }} [options]
 * @returns {{ texture: THREE.CanvasTexture; widthPx: number; heightPx: number; anchorY: number }}
 */
function createHotspotCompositeTexture(title, dpr, options) {
  const circleFill = options?.circleFill ?? '#d45200';
  const plusStroke = options?.plusStroke ?? '#282725';
  const scale = Math.max(1, Math.min(dpr, 2));
  const iconDraw = Math.round(HOTSPOT_ICON_SCREEN_PX * scale);
  const titleFont = Math.round(15 * scale);
  const pad = Math.round(8 * scale);
  const gap = Math.round(6 * scale);
  const maxTextW = HOTSPOT_TITLE_MAX_W * scale;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    const c = document.createElement('canvas');
    c.width = 64;
    c.height = 64;
    const t = new THREE.CanvasTexture(c);
    t.colorSpace = THREE.SRGBColorSpace;
    return { texture: t, widthPx: 64, heightPx: 64, anchorY: 0.5 };
  }

  const rawTitle = String(title || '').trim();
  let titleBlockH = 0;
  let titleW = 0;

  if (rawTitle) {
    ctx.font = `600 ${titleFont}px system-ui, -apple-system, "Segoe UI", sans-serif`;
    const line = ellipsizeText(ctx, rawTitle, maxTextW);
    titleW = Math.ceil(ctx.measureText(line).width + pad * 2);
    titleBlockH = Math.ceil(titleFont + pad * 2);
  }

  const w = Math.max(iconDraw + pad * 2, titleW || 0);
  const iconCenterY = rawTitle ? titleBlockH + gap + iconDraw / 2 : pad + iconDraw / 2;
  const h = Math.ceil(rawTitle ? titleBlockH + gap + iconDraw + pad : iconDraw + pad * 2);

  canvas.width = w;
  canvas.height = h;
  ctx.setTransform(1, 0, 0, 1, 0, 0);

  if (rawTitle) {
    ctx.font = `600 ${titleFont}px system-ui, -apple-system, "Segoe UI", sans-serif`;
    const line = ellipsizeText(ctx, rawTitle, maxTextW);
    const tw = ctx.measureText(line).width + pad * 2;
    const tx = (w - tw) / 2;
    const ty = 0;
    const r = Math.round(6 * scale);
    ctx.fillStyle = 'rgba(0, 0, 0, 0.72)';
    ctx.beginPath();
    if (typeof ctx.roundRect === 'function') {
      ctx.roundRect(tx, ty, tw, titleBlockH, r);
    } else {
      ctx.rect(tx, ty, tw, titleBlockH);
    }
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(line, tx + tw / 2, ty + titleBlockH / 2);
  }

  const cx = w / 2;
  const cy = iconCenterY;
  const r = iconDraw * 0.38;
  ctx.fillStyle = circleFill;
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = plusStroke;
  ctx.lineWidth = Math.max(1, iconDraw * 0.028);
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  const pl = r * 0.6;
  ctx.beginPath();
  ctx.moveTo(cx - pl, cy);
  ctx.lineTo(cx + pl, cy);
  ctx.moveTo(cx, cy - pl);
  ctx.lineTo(cx, cy + pl);
  ctx.stroke();

  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.needsUpdate = true;

  /** Sprite `center` uses (0,0) = texture bottom-left; canvas y is top-down. */
  const anchorY = (h - iconCenterY) / h;

  return {
    texture: tex,
    widthPx: w / scale,
    heightPx: h / scale,
    anchorY,
  };
}

/**
 * Screen-horizontal axis through the target (for polar-style tilt, like OrbitControls).
 * @param {THREE.Camera} cam
 * @param {THREE.Vector3} target
 */
function horizonAxisForView(cam, target) {
  const up = new THREE.Vector3(0, 1, 0);
  const forward = new THREE.Vector3().subVectors(target, cam.position);
  if (forward.lengthSq() < 1e-12) return new THREE.Vector3(1, 0, 0);
  forward.normalize();
  let right = new THREE.Vector3().crossVectors(up, forward);
  if (right.lengthSq() < 1e-12) {
    right = new THREE.Vector3().crossVectors(new THREE.Vector3(1, 0, 0), forward);
  }
  return right.normalize();
}

/**
 * Y-up spherical direction: azimuth rotates around Y (0 = +Z, 90° = +X), elevation from horizon.
 * Default 0° / 7° horizontal; theme overrides azimuth/elevation.
 * @param {number} azimuthDeg
 * @param {number} elevationDeg
 */
function cameraDirectionFromAzimuthElevation(azimuthDeg, elevationDeg) {
  const az = THREE.MathUtils.degToRad(azimuthDeg);
  const el = THREE.MathUtils.degToRad(elevationDeg);
  return new THREE.Vector3(
    Math.cos(el) * Math.sin(az),
    Math.sin(el),
    Math.cos(el) * Math.cos(az)
  ).normalize();
}

/**
 * Inverse of {@link cameraDirectionFromAzimuthElevation}: unit direction from origin → light position.
 * @param {THREE.Vector3} v world-space light position (non-zero)
 * @returns {{ azimuthDeg: number; elevationDeg: number }}
 */
function azimuthElevationDegFromPosition(v) {
  const d = v.clone();
  if (d.lengthSq() < 1e-12) {
    return { azimuthDeg: 0, elevationDeg: 0 };
  }
  d.normalize();
  const elRad = Math.asin(THREE.MathUtils.clamp(d.y, -1, 1));
  const azRad = Math.atan2(d.x, d.z);
  return {
    azimuthDeg: THREE.MathUtils.radToDeg(azRad),
    elevationDeg: THREE.MathUtils.radToDeg(elRad),
  };
}

function smoothstep01(t) {
  const s = Math.min(1, Math.max(0, t));
  return s * s * (3 - 2 * s);
}

/**
 * Ease-in-out with configurable power (e.g. 2 = quad, 3 = cubic, 4 = quartic).
 * Slow start and slow end, faster mid — “power in” + “power out”.
 * @param {number} t linear 0..1
 * @param {number} p exponent >= 1
 */
function easeInOutPow(t, p) {
  const s = Math.min(1, Math.max(0, t));
  if (s <= 0) return 0;
  if (s >= 1) return 1;
  if (s < 0.5) {
    return Math.pow(2 * s, p) / 2;
  }
  return 1 - Math.pow(-2 * s + 2, p) / 2;
}

/**
 * Ease-out: quick start, strong deceleration near t=1 (quartic/quintic when p is 4–5).
 * @param {number} t linear 0..1
 * @param {number} p exponent >= 1
 */
function easeOutPow(t, p) {
  const s = Math.min(1, Math.max(0, t));
  if (s <= 0) return 0;
  if (s >= 1) return 1;
  return 1 - Math.pow(1 - s, p);
}

/**
 * Absolute model orientation for hotspot focus (matches `modelRoot` initial rotation order YXZ).
 * @param {number[] | readonly number[]} deg [pitch, yaw, roll] in degrees
 * @returns {THREE.Quaternion}
 */
function quaternionFromHotspotRotationDeg(deg) {
  const rx = THREE.MathUtils.degToRad(Number(deg[0]) || 0);
  const ry = THREE.MathUtils.degToRad(Number(deg[1]) || 0);
  const rz = THREE.MathUtils.degToRad(Number(deg[2]) || 0);
  return new THREE.Quaternion().setFromEuler(new THREE.Euler(rx, ry, rz, 'YXZ'));
}

/**
 * @param {HTMLElement} root
 */
function initWebglRoot(root) {
  const canvas = root.querySelector('canvas[data-custom-webgl]');
  const configEl = root.querySelector('script[data-webgl-config]');
  if (!canvas || !configEl) {
    return;
  }

  /** Wraps viewport + panel; panel sits below the canvas on small screens so it is not clipped by `overflow:hidden`. */
  const stage = root.parentElement?.classList?.contains('custom-webgl__stage')
    ? root.parentElement
    : root;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch {
    return;
  }

  if (typeof root.__webglDispose === 'function') {
    try {
      root.__webglDispose();
    } catch {
      /* ignore */
    }
    root.__webglDispose = null;
  }

  const cleanups = [];
  let disposed = false;
  function registerCleanup(fn) {
    cleanups.push(fn);
  }
  root.__webglDispose = () => {
    if (disposed) return;
    disposed = true;
    for (const fn of [...cleanups]) {
      try {
        fn();
      } catch {
        /* ignore */
      }
    }
    cleanups.length = 0;
  };

  const prefersReducedMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const cameraAzimuthDeg = Number(config.cameraAzimuthDeg);
  const cameraElevationDeg = Number(config.cameraElevationDeg);
  const modelRotationXDeg = Number(config.modelRotationXDeg);
  const modelRotationYDeg = Number(config.modelRotationYDeg);
  const modelRotationZDeg = Number(config.modelRotationZDeg);
  const _axisLockRaw = String(config.modelRotateAxisLock ?? 'none');
  const modelRotateAxisLock = ['none', 'y', 'tilt'].includes(_axisLockRaw)
    ? _axisLockRaw
    : 'none';

  const enableScrollIntroAnimation =
    ENABLE_SCROLL_INTRO_ANIMATION && config.enableScrollIntroAnimation !== false;

  const showLightDebug = config.showLightDebug === true;

  const panel = stage.querySelector('[data-webgl-panel]');
  const panelTitle = stage.querySelector('[data-webgl-panel-title]');
  const panelBody = stage.querySelector('[data-webgl-panel-body]');
  const closeBtn = stage.querySelector('[data-webgl-close]');
  const loadingEl = root.querySelector('[data-webgl-loading]');
  const loadingTrack = root.querySelector('[data-webgl-loading-track]');
  const loadingFill = root.querySelector('[data-webgl-loading-fill]');
  const markersLayer = root.querySelector('[data-webgl-markers]');

  function updateLoadingProgress(xhr) {
    if (!loadingFill || !loadingTrack || !loadingEl) return;
    if (xhr.lengthComputable && xhr.total > 0) {
      const pct = Math.min(100, Math.round((xhr.loaded / xhr.total) * 100));
      loadingFill.style.width = `${pct}%`;
      loadingTrack.setAttribute('aria-valuenow', String(pct));
      loadingEl.classList.remove('custom-webgl__loading--indeterminate');
    } else {
      loadingEl.classList.add('custom-webgl__loading--indeterminate');
    }
  }

  function hideLoading() {
    if (!loadingEl) return;
    loadingEl.hidden = true;
    loadingEl.setAttribute('aria-hidden', 'true');
  }

  /** Set after GLB load so close can restore camera + model rotation. */
  let closePanelImpl = null;

  function closePanel() {
    if (closePanelImpl) closePanelImpl();
    else if (panel) {
      panel.hidden = true;
    }
  }

  const acPre = new AbortController();
  registerCleanup(() => acPre.abort());

  function onDocKeydown(e) {
    if (e.key !== 'Escape' || !panel || panel.hidden) return;
    closePanel();
  }
  document.addEventListener('keydown', onDocKeydown, { signal: acPre.signal });
  if (closeBtn) {
    closeBtn.addEventListener('click', closePanel, { signal: acPre.signal });
  }

  const scene = new THREE.Scene();
  scene.background = null;

  const renderer = new THREE.WebGLRenderer({
    canvas,
    alpha: true,
    antialias: true,
    powerPreference: 'high-performance',
    premultipliedAlpha: false,
  });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setClearColor(0x000000, 0);
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  /** PBR + ACES: tune with `scene.environmentIntensity` and light intensities (was too hot at ~2.35). */
  renderer.toneMappingExposure = 0.9;

  const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 200);
  camera.position.set(1.2, 0.8, 1.8);

  const controls = new OrbitControls(camera, canvas);
  controls.enableDamping = true;
  controls.dampingFactor = 0.14;
  controls.minDistance = 0.2;
  controls.maxDistance = 20;
  controls.enableZoom = config.enableZoom === true;
  controls.enableRotate = false;
  controls.enablePan = false;

  /** Sky / ground hemispherical fill. */
  const hemi = new THREE.HemisphereLight(0xffffff, 0x808080, 0.3);

  /** Even non-directional fill (true ambient). */
  const ambient = new THREE.AmbientLight(0xffffff, 0.05);

  const keyLight = new THREE.DirectionalLight(0xffffff, 4);
  keyLight.position.set(9.5405, 6.1927, 6.6804);

  const fillLight = new THREE.DirectionalLight(0xfff8f5, 3.55);
  fillLight.position.set(-4.4882, 6.0482, 6.654);

  const backLight = new THREE.DirectionalLight(0xffffff, 0);
  backLight.position.set(0, 5, -9);

  const lightsById = {
    hemi,
    ambient,
    key: keyLight,
    fill: fillLight,
    back: backLight,
  };

  let lightIsolateMode =
    LIGHT_ISOLATE !== null && LIGHT_DEBUG_IDS.includes(LIGHT_ISOLATE) ? LIGHT_ISOLATE : 'all';
  /** No-op until light-debug UI + helpers exist (after GLB load). */
  let syncLightDebugVis = () => {};

  function applyLightIsolate() {
    for (const [id, light] of Object.entries(lightsById)) {
      light.visible = lightIsolateMode === 'all' || lightIsolateMode === id;
    }
    syncLightDebugVis();
  }

  scene.add(hemi, ambient, keyLight, fillLight, backLight);
  applyLightIsolate();

  const raycaster = new THREE.Raycaster();
  const pointer = new THREE.Vector2();
  const hotspotMeshes = [];

  /** Assigned after GLB load; updates OrbitControls mode, hotspot scale, and clears spin on resize. */
  let applyWebglViewportInteractionMode = () => {};

  function resizeView() {
    const w = root.clientWidth;
    const h = root.clientHeight;
    if (w < 2 || h < 2) {
      return;
    }
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
    renderer.setSize(w, h, false);
    syncLightDebugVis();
    applyWebglViewportInteractionMode();
  }

  resizeView();
  const resizeObserver = new ResizeObserver(resizeView);
  resizeObserver.observe(root);
  registerCleanup(() => resizeObserver.disconnect());

  registerCleanup(() => {
    try {
      controls.dispose();
    } catch {
      /* ignore */
    }
    try {
      renderer.dispose();
    } catch {
      /* ignore */
    }
  });

  /** PBR materials need an env map or they look almost black. */
  const pmremGenerator = new THREE.PMREMGenerator(renderer);
  scene.environment = pmremGenerator.fromScene(new RoomEnvironment(), 0.04);
  scene.environmentIntensity = 0.82;
  pmremGenerator.dispose();

  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath(DRACO_DECODER_BASE);
  dracoLoader.preload();
  registerCleanup(() => {
    try {
      dracoLoader.dispose();
    } catch {
      /* ignore */
    }
  });

  const loader = new GLTFLoader();
  loader.setDRACOLoader(dracoLoader);

  loader.load(
    config.modelUrl,
    (gltf) => {
      if (disposed) {
        try {
          dracoLoader.dispose();
        } catch {
          /* ignore */
        }
        return;
      }
      dracoLoader.dispose();

      const acLoaded = new AbortController();
      registerCleanup(() => acLoaded.abort());

      if (loadingFill) loadingFill.style.width = '100%';
      if (loadingTrack) loadingTrack.setAttribute('aria-valuenow', '100');
      hideLoading();

      const box = new THREE.Box3().setFromObject(gltf.scene);
      const center = box.getCenter(new THREE.Vector3());
      const size = box.getSize(new THREE.Vector3());
      const maxDim = Math.max(size.x, size.y, size.z, 0.001);
      /** Filled when light-debug panel is on; `update()` each frame for visible helpers. */
      let lightDebugHelpersWithUpdate = [];
      const modelYOffset = maxDim * MODEL_VERTICAL_OFFSET_RATIO;

      gltf.scene.position.sub(center);

      gltf.scene.traverse((child) => {
        if (!child.isMesh) return;
        const mats = Array.isArray(child.material) ? child.material : [child.material];
        for (const m of mats) {
          if (!m) continue;
          if (m.isMeshStandardMaterial || m.isMeshPhysicalMaterial) {
            const cur = Number(m.envMapIntensity);
            m.envMapIntensity = Number.isFinite(cur) && cur > 0.1 ? Math.max(cur, 0.85) : 1.0;
            m.needsUpdate = true;
          }
        }
      });

      const modelRoot = new THREE.Group();
      modelRoot.add(gltf.scene);
      modelRoot.position.y = modelYOffset;
      const mrx = Number.isFinite(modelRotationXDeg) ? modelRotationXDeg : 0;
      const mry = Number.isFinite(modelRotationYDeg) ? modelRotationYDeg : 0;
      const mrz = Number.isFinite(modelRotationZDeg) ? modelRotationZDeg : 0;
      modelRoot.rotation.set(
        THREE.MathUtils.degToRad(mrx),
        THREE.MathUtils.degToRad(mry),
        THREE.MathUtils.degToRad(mrz),
        'YXZ'
      );
      scene.add(modelRoot);

      const boxCentered = new THREE.Box3().setFromObject(modelRoot);
      const boundSphere = new THREE.Sphere();
      boxCentered.getBoundingSphere(boundSphere);

      const fitDist = maxDim * INITIAL_CAMERA_FIT_MULTIPLIER;
      /** Section “Initial model zoom” — same scale as `focus_zoom` in focus pose JSON / pose tuner. */
      const sectionInitialZoom = clampFocusZoom(
        Number.isFinite(Number(config.initialFocusZoom)) ? Number(config.initialFocusZoom) : FOCUS_ZOOM_DEFAULT
      );
      const loadDist = Math.max(
        fitDist * (sectionInitialZoom / FOCUS_ZOOM_DIST_REF),
        maxDim * TUNER_FOCUS_MIN_DIST_FACTOR
      );
      const az = Number.isFinite(cameraAzimuthDeg) ? cameraAzimuthDeg : 0;
      const el = Number.isFinite(cameraElevationDeg) ? cameraElevationDeg : 7;
      const dirVec = cameraDirectionFromAzimuthElevation(az, el);
      const orbitTarget = new THREE.Vector3(0, modelYOffset, 0);
      camera.position.copy(orbitTarget.clone().add(dirVec.clone().multiplyScalar(loadDist)));

      /**
       * Distance from camera to closest point on the mesh’s bounding sphere (target at origin).
       * Near plane must stay well below this or the entire model is clipped (grey, empty view).
       */
      const distCam = loadDist;
      const minAlongView = Math.max(1e-8, distCam - boundSphere.radius);
      let n = Math.min(minAlongView * 0.08, distCam / 8000);
      if (n >= minAlongView) n = minAlongView * 0.05;
      camera.near = Math.max(1e-8, n);
      if (camera.near >= minAlongView) camera.near = minAlongView * 0.04;
      camera.far = Math.max(
        distCam + boundSphere.radius * 2.5,
        controls.maxDistance + boundSphere.radius * 2.5,
        10
      );
      camera.updateProjectionMatrix();
      controls.target.copy(orbitTarget);
      camera.lookAt(orbitTarget);
      if (config.enableZoom) {
        /** Keep scroll/pinch zoom from pushing the camera inside the fitted bounding sphere. */
        controls.minDistance = Math.max(controls.minDistance, boundSphere.radius * 1.06);
      }
      controls.update();

      const lightDebugRoot = root.querySelector('[data-webgl-light-debug]');
      if (showLightDebug && lightDebugRoot) {
        const hSize = Math.max(maxDim * 0.28, 0.22);
        const chkShow = lightDebugRoot.querySelector('[data-light-debug-show]');
        const selIsolate = lightDebugRoot.querySelector('[data-light-isolate]');

        const hemiH = new THREE.HemisphereLightHelper(hemi, hSize * 0.9);
        const keyH = new THREE.DirectionalLightHelper(keyLight, hSize, 0xffd966);
        const fillH = new THREE.DirectionalLightHelper(fillLight, hSize * 0.92, 0x88ccff);
        const backH = new THREE.DirectionalLightHelper(backLight, hSize * 0.88, 0xc9a0ff);

        const ambR = Math.max(hSize * 0.11, 0.04);
        const ambGeo = new THREE.SphereGeometry(ambR, 10, 8);
        const ambMat = new THREE.MeshBasicMaterial({
          color: 0x888888,
          wireframe: true,
          transparent: true,
          opacity: 0.65,
        });
        const ambientWire = new THREE.Mesh(ambGeo, ambMat);
        ambientWire.position.set(0, 0, 0);

        const helpersById = {
          hemi: hemiH,
          key: keyH,
          fill: fillH,
          back: backH,
        };

        for (const h of Object.values(helpersById)) {
          scene.add(h);
        }
        scene.add(ambientWire);

        lightDebugHelpersWithUpdate = [hemiH, keyH, fillH, backH];

        function fmtLightIntensity(v) {
          return String(Math.round(Number(v) * 100) / 100);
        }

        const lightIntensityIds = ['hemi', 'ambient', 'key', 'fill', 'back'];
        for (const id of lightIntensityIds) {
          const inp = lightDebugRoot.querySelector(`input[data-light-int="${id}"]`);
          const out = lightDebugRoot.querySelector(`output[data-light-int-out="${id}"]`);
          const light = lightsById[id];
          if (!inp || !light) continue;
          inp.value = String(light.intensity);
          if (out) out.textContent = fmtLightIntensity(light.intensity);
          inp.addEventListener(
            'input',
            () => {
              const v = Number(inp.value);
              light.intensity = Number.isFinite(v) ? v : light.intensity;
              if (out) out.textContent = fmtLightIntensity(light.intensity);
            },
            { signal: acLoaded.signal }
          );
        }

        const keyOrientDist = Math.max(keyLight.position.length(), 0.01);
        const fillOrientDist = Math.max(fillLight.position.length(), 0.01);

        const inpKeyAz = lightDebugRoot.querySelector('[data-light-key-az]');
        const inpKeyEl = lightDebugRoot.querySelector('[data-light-key-el]');
        const inpFillAz = lightDebugRoot.querySelector('[data-light-fill-az]');
        const inpFillEl = lightDebugRoot.querySelector('[data-light-fill-el]');
        const outKeyAz = lightDebugRoot.querySelector('[data-light-key-az-out]');
        const outKeyEl = lightDebugRoot.querySelector('[data-light-key-el-out]');
        const outFillAz = lightDebugRoot.querySelector('[data-light-fill-az-out]');
        const outFillEl = lightDebugRoot.querySelector('[data-light-fill-el-out]');

        function fmtDegUi(v) {
          const n = Number(v);
          if (!Number.isFinite(n)) return '0';
          return String(Math.round(n * 10) / 10);
        }

        function clampLightAz(az) {
          return Math.max(-180, Math.min(180, az));
        }

        function clampLightEl(el) {
          return Math.max(-89, Math.min(89, el));
        }

        function applyKeyOrientation() {
          const az = Number(inpKeyAz?.value);
          const el = Number(inpKeyEl?.value);
          if (!Number.isFinite(az) || !Number.isFinite(el)) return;
          keyLight.position.copy(
            cameraDirectionFromAzimuthElevation(az, clampLightEl(el)).multiplyScalar(keyOrientDist)
          );
          if (outKeyAz) outKeyAz.textContent = fmtDegUi(inpKeyAz?.value);
          if (outKeyEl) outKeyEl.textContent = fmtDegUi(inpKeyEl?.value);
        }

        function applyFillOrientation() {
          const az = Number(inpFillAz?.value);
          const el = Number(inpFillEl?.value);
          if (!Number.isFinite(az) || !Number.isFinite(el)) return;
          fillLight.position.copy(
            cameraDirectionFromAzimuthElevation(az, clampLightEl(el)).multiplyScalar(fillOrientDist)
          );
          if (outFillAz) outFillAz.textContent = fmtDegUi(inpFillAz?.value);
          if (outFillEl) outFillEl.textContent = fmtDegUi(inpFillEl?.value);
        }

        function syncKeyFillOrientationFromLights() {
          const k = azimuthElevationDegFromPosition(keyLight.position);
          const f = azimuthElevationDegFromPosition(fillLight.position);
          if (inpKeyAz) inpKeyAz.value = String(Math.round(clampLightAz(k.azimuthDeg)));
          if (inpKeyEl) inpKeyEl.value = String(Math.round(clampLightEl(k.elevationDeg)));
          if (inpFillAz) inpFillAz.value = String(Math.round(clampLightAz(f.azimuthDeg)));
          if (inpFillEl) inpFillEl.value = String(Math.round(clampLightEl(f.elevationDeg)));
          applyKeyOrientation();
          applyFillOrientation();
        }

        [inpKeyAz, inpKeyEl].forEach((inp) => {
          if (!inp) return;
          inp.addEventListener('input', applyKeyOrientation, { signal: acLoaded.signal });
        });
        [inpFillAz, inpFillEl].forEach((inp) => {
          if (!inp) return;
          inp.addEventListener('input', applyFillOrientation, { signal: acLoaded.signal });
        });

        syncKeyFillOrientationFromLights();

        let showHelpersUi = false;

        syncLightDebugVis = () => {
          const viewportAllowsDebugUi =
            typeof window !== 'undefined' && window.innerWidth >= 1000;
          const showLines = showHelpersUi && showLightDebug && viewportAllowsDebugUi;
          for (const [id, helper] of Object.entries(helpersById)) {
            helper.visible = showLines && lightsById[id].visible === true;
          }
          ambientWire.visible = showLines && lightsById.ambient.visible === true;
        };

        if (selIsolate) selIsolate.value = lightIsolateMode;

        function readIsolateFromSelect() {
          const v = selIsolate?.value ?? 'all';
          if (v === 'all' || LIGHT_DEBUG_IDS.includes(v)) return v;
          return 'all';
        }

        function onIsolateChange() {
          lightIsolateMode = readIsolateFromSelect();
          applyLightIsolate();
        }

        function onShowChange() {
          showHelpersUi = chkShow?.checked === true;
          syncLightDebugVis();
        }

        chkShow?.addEventListener('change', onShowChange, { signal: acLoaded.signal });
        selIsolate?.addEventListener('change', onIsolateChange, { signal: acLoaded.signal });

        onShowChange();
        onIsolateChange();

        const copyPresetOut = lightDebugRoot.querySelector('[data-light-copy-preset-out]');
        const copyPresetBtn = lightDebugRoot.querySelector('[data-light-copy-preset]');

        function fmtPresetNum(n) {
          const x = Number(n);
          if (!Number.isFinite(x)) return '0';
          return String(Math.round(x * 10000) / 10000);
        }

        function buildLightPresetForCustomJs() {
          const k = azimuthElevationDegFromPosition(keyLight.position);
          const f = azimuthElevationDegFromPosition(fillLight.position);
          const kd = keyLight.position.length();
          const fd = fillLight.position.length();
          return [
            '// Paste into assets/custom.js inside initWebglRoot(), after the directional lights are created.',
            '// Option A: Replace the intensity + position.set(...) lines under "Sky / ground hemispherical".',
            '// Option B: Paste these lines right after backLight.position.set(0, 5, -9); (they override defaults).',
            '',
            `hemi.intensity = ${fmtPresetNum(hemi.intensity)};`,
            `ambient.intensity = ${fmtPresetNum(ambient.intensity)};`,
            `keyLight.intensity = ${fmtPresetNum(keyLight.intensity)};`,
            `fillLight.intensity = ${fmtPresetNum(fillLight.intensity)};`,
            `backLight.intensity = ${fmtPresetNum(backLight.intensity)};`,
            `keyLight.position.set(${fmtPresetNum(keyLight.position.x)}, ${fmtPresetNum(keyLight.position.y)}, ${fmtPresetNum(keyLight.position.z)});`,
            `fillLight.position.set(${fmtPresetNum(fillLight.position.x)}, ${fmtPresetNum(fillLight.position.y)}, ${fmtPresetNum(fillLight.position.z)});`,
            `backLight.position.set(${fmtPresetNum(backLight.position.x)}, ${fmtPresetNum(backLight.position.y)}, ${fmtPresetNum(backLight.position.z)});`,
            '// Reference — key / fill orientation (same convention as camera az/el in this file):',
            `//   key  ~ ${k.azimuthDeg.toFixed(1)}° az, ${k.elevationDeg.toFixed(1)}° el, dist ${kd.toFixed(3)}`,
            `//   fill ~ ${f.azimuthDeg.toFixed(1)}° az, ${f.elevationDeg.toFixed(1)}° el, dist ${fd.toFixed(3)}`,
          ].join('\n');
        }

        if (copyPresetBtn) {
          copyPresetBtn.addEventListener(
            'click',
            async () => {
              const text = buildLightPresetForCustomJs();
              try {
                await navigator.clipboard.writeText(text);
                if (copyPresetOut) copyPresetOut.textContent = 'Copied to clipboard:\n\n' + text;
              } catch {
                if (copyPresetOut) copyPresetOut.textContent = text;
              }
            },
            { signal: acLoaded.signal }
          );
        }

        lightDebugRoot.hidden = false;

        registerCleanup(() => {
          for (const h of lightDebugHelpersWithUpdate) {
            scene.remove(h);
            if (typeof h.dispose === 'function') h.dispose();
          }
          scene.remove(ambientWire);
          ambGeo.dispose();
          ambMat.dispose();
          lightDebugHelpersWithUpdate = [];
          syncLightDebugVis = () => {};
        });
      }

      const tunerDom = root.querySelector('[data-webgl-model-tuner]');
      const hotspotsRaw = Array.isArray(config.hotspots) ? config.hotspots : [];
      let hotspotList = hotspotsRaw.map(normalizeHotspotFromTheme);
      if (ENABLE_HOTSPOTS && tunerDom) {
        const elPx = tunerDom.querySelector('[data-tuner-px]');
        const elPy = tunerDom.querySelector('[data-tuner-py]');
        const elPz = tunerDom.querySelector('[data-tuner-pz]');
        const px = Number.parseFloat(elPx?.value ?? '');
        const py = Number.parseFloat(elPy?.value ?? '');
        const pz = Number.parseFloat(elPz?.value ?? '');
        const clampPosX = (v, fallback) => {
          const n = Number.isFinite(v) ? v : fallback;
          return Math.max(-HOTSPOT_POSITION_XY_MAX, Math.min(HOTSPOT_POSITION_XY_MAX, n));
        };
        const clampPosY = (v, fallback) => {
          const n = Number.isFinite(v) ? v : fallback;
          return Math.max(-HOTSPOT_POSITION_XY_MAX, Math.min(HOTSPOT_POSITION_XY_MAX, n));
        };
        const clampPosZ = (v, fallback) => {
          const n = Number.isFinite(v) ? v : fallback;
          return Math.max(-HOTSPOT_POSITION_Z_MAX, Math.min(HOTSPOT_POSITION_Z_MAX, n));
        };
        /** Extra marker (blue); position sliders move only this sprite, not theme hotspots. */
        hotspotList.push({
          id: 'tuner-demo-hotspot',
          title: '',
          body: 'Copy the position JSON from the tuner into a Hotspot block.',
          position: [clampPosX(px, 0), clampPosY(py, 0), clampPosZ(pz, 0.5)],
          useCustomRotation: false,
          rotationDeg: [0, 0, 0],
          focusZoomAlong: sectionInitialZoom,
          focusPanX: 0,
          focusPanY: 0,
        });
      }
      const dpr = renderer.getPixelRatio();
      const useHtmlLabels = HOTSPOT_HTML_LABELS && !!markersLayer;
      /** @type {{ sprite: THREE.Sprite; el: HTMLElement }[]} */
      const htmlLabelEntries = [];
      const labelWorld = new THREE.Vector3();
      const labelToCam = new THREE.Vector3();
      const cameraDir = new THREE.Vector3();

      function setHotspotLabelActive(activeSprite) {
        if (!useHtmlLabels || htmlLabelEntries.length === 0) return;
        for (const { sprite, el } of htmlLabelEntries) {
          const on = activeSprite != null && sprite === activeSprite;
          el.classList.toggle('custom-webgl__hotspot-label--active', on);
        }
      }

      function updateHotspotHtmlLabels() {
        if (!useHtmlLabels || htmlLabelEntries.length === 0 || !modelRoot) return;
        const w = root.clientWidth;
        const h = root.clientHeight;
        if (w < 2 || h < 2) return;
        modelRoot.updateMatrixWorld(true);
        camera.getWorldDirection(cameraDir);
        for (const entry of htmlLabelEntries) {
          const { sprite, el } = entry;
          if (!sprite || !el) continue;
          sprite.getWorldPosition(labelWorld);
          labelToCam.subVectors(labelWorld, camera.position);
          if (labelToCam.dot(cameraDir) <= 0) {
            el.hidden = true;
            continue;
          }
          labelWorld.project(camera);
          const px = (labelWorld.x * 0.5 + 0.5) * w;
          const py = (-labelWorld.y * 0.5 + 0.5) * h;
          el.hidden = false;
          el.style.left = `${px}px`;
          el.style.top = `${py}px`;
        }
      }

      /** Blue `tuner-demo-hotspot` sprite — moved by the position sliders when the tuner is on. */
      let tunerHotspotSprite = null;

      if (ENABLE_HOTSPOTS) {
        hotspotList.forEach((h, i) => {
          if (!h.position || h.position.length < 3) {
            return;
          }
          const pos = new THREE.Vector3(
            h.position[0] * HOTSPOT_POSITION_SCALE,
            h.position[1] * HOTSPOT_POSITION_SCALE,
            h.position[2] * HOTSPOT_POSITION_SCALE
          );

          const titleForCanvas = useHtmlLabels ? '' : h.title;
          const textureOpts =
            h.id === 'tuner-demo-hotspot'
              ? { circleFill: '#2563eb', plusStroke: '#ffffff' }
              : undefined;
          const { texture, widthPx, heightPx, anchorY } = createHotspotCompositeTexture(
            titleForCanvas,
            dpr,
            textureOpts
          );
          const worldPerLayoutPx =
            (maxDim * HOTSPOT_TARGET_WORLD_FACTOR) / HOTSPOT_DESIGN_REF_PX;

          const mat = new THREE.SpriteMaterial({
            map: texture,
            transparent: true,
            opacity: 1,
            sizeAttenuation: false,
            depthTest: HOTSPOT_OCCLUDE_BY_DEPTH,
            depthWrite: false,
          });
          const sprite = new THREE.Sprite(mat);
          sprite.center.set(0.5, anchorY);
          const sx = widthPx * worldPerLayoutPx;
          const sy = heightPx * worldPerLayoutPx;
          sprite.scale.set(sx, sy, 1);
          sprite.userData.hotspotBaseScale = { x: sx, y: sy };
          sprite.position.copy(pos);
          sprite.userData.hotspot = h;
          /** After opaque mesh; transparent pass still depth-tests against mesh if `depthTest` is on. */
          sprite.renderOrder = 1;
          gltf.scene.add(sprite);
          hotspotMeshes.push(sprite);
          if (useHtmlLabels && String(h.title || '').trim()) {
            const el = document.createElement('div');
            el.className = 'custom-webgl__hotspot-label';
            if (h.id === 'tuner-demo-hotspot') {
              el.classList.add('custom-webgl__hotspot-label--positional');
            }
            const anchor = document.createElement('div');
            anchor.className = 'custom-webgl__hotspot-label__anchor';
            const hitEl = document.createElement('div');
            hitEl.className = 'custom-webgl__hotspot-label__hit';
            hitEl.setAttribute('aria-hidden', 'true');
            const textEl = document.createElement('div');
            textEl.className = 'custom-webgl__hotspot-label__text';
            textEl.textContent = h.title;
            anchor.appendChild(hitEl);
            anchor.appendChild(textEl);
            el.appendChild(anchor);
            markersLayer.appendChild(el);
            htmlLabelEntries.push({ sprite, el });
          }
        });
        tunerHotspotSprite =
          hotspotMeshes.find((s) => s.userData.hotspot?.id === 'tuner-demo-hotspot') ?? null;
      }

      /** Hotspot click: rotate model + dolly camera toward marker. */
      let focusAnim = null;
      /** After a hotspot opens, the next pointerdown outside the panel closes + restores zoom. */
      let panelDismissOnNextPointerDown = false;
      /** Skip one canvas pointerup hotspot pick (after dismiss pointerdown) so the same gesture cannot reopen. */
      let suppressNextCanvasHotspotPick = false;
      /** Snapshot before first hotspot open this session; restored when panel closes. */
      let sessionRestore = null;
      /** Sprite for the hotspot whose panel is open; used to switch vs reset on the next click. */
      let activeHotspotSprite = null;
      let defocusAnim = null;
      /** Scroll-triggered intro: Y −4° then +364° ease-out (world axis), ends on start quat. */
      let introScrollAnim = null;
      /** Once true, intro never runs again (also avoids re-trigger on resize). */
      let scrollIntroDone = false;
      /** Same idea as OrbitControls.sphericalDelta — applied each frame, then damped. Declared early so tuner `cancelIntroForTuner` can reset before pointer handlers. */
      let spinDeltaYaw = 0;
      let spinDeltaTilt = 0;
      const focusWorldScratch = new THREE.Vector3();
      const worldUpY = new THREE.Vector3(0, 1, 0);

      applyWebglViewportInteractionMode = () => {
        const desktop = isWebglDesktopViewport();
        controls.enabled = desktop;
        controls.enableZoom = config.enableZoom === true && desktop;
        spinDeltaYaw = 0;
        spinDeltaTilt = 0;
        if (!desktop && introScrollAnim && modelRoot) {
          modelRoot.quaternion.copy(introScrollAnim.q0);
          introScrollAnim = null;
          scrollIntroDone = true;
          root.classList.remove('custom-webgl__viewport--intro-anim');
        }
        const m = desktop ? 1 : WEBGL_HOTSPOT_MOBILE_SCALE;
        for (const sprite of hotspotMeshes) {
          const b = sprite.userData.hotspotBaseScale;
          if (b) sprite.scale.set(b.x * m, b.y * m, 1);
        }
      };
      applyWebglViewportInteractionMode();

      /** Theme `focus_pan_x` / `focus_pan_y` (±`FOCUS_PAN_THEME_MAX`) → world translation on `modelRoot` while focused / in tuner. */
      function focusPanXWorldFromUnits(u) {
        const t = Number(u);
        if (!Number.isFinite(t)) return 0;
        return (
          Math.max(-FOCUS_PAN_THEME_MAX, Math.min(FOCUS_PAN_THEME_MAX, t)) * maxDim * FOCUS_PAN_X_SCALE
        );
      }
      function focusPanYWorldFromUnits(u) {
        const t = Number(u);
        if (!Number.isFinite(t)) return 0;
        return (
          Math.max(-FOCUS_PAN_THEME_MAX, Math.min(FOCUS_PAN_THEME_MAX, t)) * maxDim * FOCUS_PAN_Y_SCALE
        );
      }

      /** Bottom-left: hotspot position (blue) + pose; copy JSON for Hotspot blocks. */
      const tunerEl = root.querySelector('[data-webgl-model-tuner]');
      if (tunerEl) {
        const tunerViewDir = dirVec.clone().normalize();
        const tunerBaseDist = fitDist;
        const inpPx = tunerEl.querySelector('[data-tuner-px]');
        const inpPy = tunerEl.querySelector('[data-tuner-py]');
        const inpPz = tunerEl.querySelector('[data-tuner-pz]');
        const inpRx = tunerEl.querySelector('[data-tuner-rx]');
        const inpRy = tunerEl.querySelector('[data-tuner-ry]');
        const inpRz = tunerEl.querySelector('[data-tuner-rz]');
        const inpZoom = tunerEl.querySelector('[data-tuner-zoom]');
        const inpFocusPx = tunerEl.querySelector('[data-tuner-focus-px]');
        const inpFocusPy = tunerEl.querySelector('[data-tuner-focus-py]');
        const outPx = tunerEl.querySelector('[data-tuner-px-out]');
        const outPy = tunerEl.querySelector('[data-tuner-py-out]');
        const outPz = tunerEl.querySelector('[data-tuner-pz-out]');
        const outRx = tunerEl.querySelector('[data-tuner-rx-out]');
        const outRy = tunerEl.querySelector('[data-tuner-ry-out]');
        const outRz = tunerEl.querySelector('[data-tuner-rz-out]');
        const outZoom = tunerEl.querySelector('[data-tuner-zoom-out]');
        const outFocusPx = tunerEl.querySelector('[data-tuner-focus-px-out]');
        const outFocusPy = tunerEl.querySelector('[data-tuner-focus-py-out]');
        const previewPos = tunerEl.querySelector('[data-tuner-preview-pos]');
        const previewPose = tunerEl.querySelector('[data-tuner-preview-pose]');
        const copyPos = tunerEl.querySelector('[data-tuner-copy-pos]');
        const copyPose = tunerEl.querySelector('[data-tuner-copy-pose]');
        const presetFront = tunerEl.querySelector('[data-tuner-preset-front]');
        const presetBack = tunerEl.querySelector('[data-tuner-preset-back]');
        const resetPoseBtn = tunerEl.querySelector('[data-tuner-reset-pose]');

        function round1(n) {
          return Math.round(Number(n) * 10) / 10;
        }

        function roundZoomUi(n) {
          return roundFocusZoomStep(n);
        }

        function round2(n) {
          return Math.round(Number(n) * 100) / 100;
        }

        /** Section “Initial model zoom” — pose tuner preview matches first-load framing (per-hotspot zoom is JSON-only). */
        const h0Zoom = sectionInitialZoom;

        const tunerPosHotspot = hotspotList.find((h) => h.id === 'tuner-demo-hotspot');
        if (tunerPosHotspot && Array.isArray(tunerPosHotspot.position) && tunerPosHotspot.position.length >= 3) {
          if (inpPx) inpPx.value = String(round2(tunerPosHotspot.position[0]));
          if (inpPy) inpPy.value = String(round2(tunerPosHotspot.position[1]));
          if (inpPz) inpPz.value = String(round2(tunerPosHotspot.position[2]));
        }
        if (inpZoom) inpZoom.value = String(roundZoomUi(h0Zoom));
        if (inpFocusPx) inpFocusPx.value = '0';
        if (inpFocusPy) inpFocusPy.value = '0';

        /** Snap to slider steps; snapshot theme defaults after inputs are filled (Liquid + focus zoom/pan). */
        const poseResetRx = Math.round((Number(inpRx?.value) || 0) / 2) * 2;
        const poseResetRy = Math.round((Number(inpRy?.value) || 0) / 2) * 2;
        const poseResetRz = Math.round((Number(inpRz?.value) || 0) / 4) * 4;

        function cancelIntroForTuner() {
          focusAnim = null;
          defocusAnim = null;
          introScrollAnim = null;
          root.classList.remove('custom-webgl__viewport--intro-anim');
          scrollIntroDone = true;
          spinDeltaYaw = 0;
          spinDeltaTilt = 0;
          controls.enableDamping = true;
        }

        function getTunerPosSettings() {
          return {
            pos_x: round2(inpPx?.value ?? 0),
            pos_y: round2(inpPy?.value ?? 0),
            pos_z: round2(inpPz?.value ?? 0.5),
          };
        }

        function getTunerPoseSettings() {
          const zNum = Number(inpZoom?.value);
          return {
            use_custom_rotation: true,
            rotation_x: Number(inpRx?.value) || 0,
            rotation_y: Number(inpRy?.value) || 0,
            rotation_z: Number(inpRz?.value) || 0,
            focus_zoom: roundZoomUi(Number.isFinite(zNum) ? zNum : FOCUS_ZOOM_DEFAULT),
            focus_pan_x: round2(inpFocusPx?.value ?? 0),
            focus_pan_y: round2(inpFocusPy?.value ?? 0),
          };
        }

        function syncTunerPosOutputs() {
          if (outPx) outPx.textContent = String(round2(inpPx?.value ?? 0));
          if (outPy) outPy.textContent = String(round2(inpPy?.value ?? 0));
          if (outPz) outPz.textContent = String(round2(inpPz?.value ?? 0.5));
        }

        function syncTunerPoseOutputs() {
          if (outRx) outRx.textContent = String(Math.round(Number(inpRx?.value) || 0));
          if (outRy) outRy.textContent = String(Math.round(Number(inpRy?.value) || 0));
          if (outRz) outRz.textContent = String(Math.round(Number(inpRz?.value) || 0));
          if (outZoom) {
            const z = Number(inpZoom?.value);
            outZoom.textContent = String(roundZoomUi(Number.isFinite(z) ? z : FOCUS_ZOOM_DEFAULT));
          }
          if (outFocusPx) outFocusPx.textContent = String(round2(inpFocusPx?.value ?? 0));
          if (outFocusPy) outFocusPy.textContent = String(round2(inpFocusPy?.value ?? 0));
        }

        function applyTunerPosition() {
          cancelIntroForTuner();
          const px = Math.max(
            -HOTSPOT_POSITION_XY_MAX,
            Math.min(HOTSPOT_POSITION_XY_MAX, round2(inpPx?.value ?? 0))
          );
          const py = Math.max(
            -HOTSPOT_POSITION_XY_MAX,
            Math.min(HOTSPOT_POSITION_XY_MAX, round2(inpPy?.value ?? 0))
          );
          const pz = Math.max(
            -HOTSPOT_POSITION_Z_MAX,
            Math.min(HOTSPOT_POSITION_Z_MAX, round2(inpPz?.value ?? 0.5))
          );
          if (tunerHotspotSprite) {
            tunerHotspotSprite.position.set(
              px * HOTSPOT_POSITION_SCALE,
              py * HOTSPOT_POSITION_SCALE,
              pz * HOTSPOT_POSITION_SCALE
            );
            const h = tunerHotspotSprite.userData.hotspot;
            if (h && Array.isArray(h.position) && h.position.length >= 3) {
              h.position[0] = px;
              h.position[1] = py;
              h.position[2] = pz;
            }
          }
        }

        function applyTunerPose() {
          cancelIntroForTuner();

          const rx = Number(inpRx?.value) || 0;
          const ry = Number(inpRy?.value) || 0;
          const rz = Number(inpRz?.value) || 0;
          const zIn = Number(inpZoom?.value);
          const fz = clampFocusZoom(Number.isFinite(zIn) ? zIn : FOCUS_ZOOM_DEFAULT);

          modelRoot.rotation.set(
            THREE.MathUtils.degToRad(rx),
            THREE.MathUtils.degToRad(ry),
            THREE.MathUtils.degToRad(rz),
            'YXZ'
          );
          modelRoot.position.x = focusPanXWorldFromUnits(inpFocusPx?.value);
          modelRoot.position.y = modelYOffset + focusPanYWorldFromUnits(inpFocusPy?.value);
          modelRoot.updateMatrixWorld(true);

          const rawDist = tunerBaseDist * (fz / FOCUS_ZOOM_DIST_REF);
          const minDist = maxDim * TUNER_FOCUS_MIN_DIST_FACTOR;
          const dist = Math.max(rawDist, minDist);
          camera.position.copy(orbitTarget.clone().add(tunerViewDir.clone().multiplyScalar(dist)));
          camera.lookAt(orbitTarget);
          controls.target.copy(orbitTarget);
          controls.update();
        }

        async function copyTo(pre, text) {
          try {
            await navigator.clipboard.writeText(text);
            if (pre) pre.textContent = 'Copied:\n\n' + text;
          } catch {
            if (pre) pre.textContent = text;
          }
        }

        syncTunerPosOutputs();
        syncTunerPoseOutputs();
        applyTunerPosition();
        applyTunerPose();
        tunerEl.hidden = false;

        [inpPx, inpPy, inpPz].forEach((inp) => {
          if (!inp) return;
          inp.addEventListener(
            'input',
            () => {
              syncTunerPosOutputs();
              applyTunerPosition();
            },
            { signal: acLoaded.signal }
          );
        });

        [inpRx, inpRy, inpRz, inpFocusPx, inpFocusPy, inpZoom].forEach((inp) => {
          if (!inp) return;
          inp.addEventListener(
            'input',
            () => {
              if (inp === inpZoom) {
                const z = roundFocusZoomStep(Number(inp.value));
                inp.value = String(z);
              }
              syncTunerPoseOutputs();
              applyTunerPose();
            },
            { signal: acLoaded.signal }
          );
        });

        if (copyPos) {
          copyPos.addEventListener(
            'click',
            () => copyTo(previewPos, JSON.stringify(getTunerPosSettings(), null, 2)),
            { signal: acLoaded.signal }
          );
        }
        if (copyPose) {
          copyPose.addEventListener(
            'click',
            () => copyTo(previewPose, JSON.stringify(getTunerPoseSettings(), null, 2)),
            { signal: acLoaded.signal }
          );
        }
        function applyPoseViewPreset(rotationYDeg) {
          if (inpRx) inpRx.value = '0';
          if (inpRy) inpRy.value = String(rotationYDeg);
          if (inpRz) inpRz.value = '0';
          if (inpZoom) inpZoom.value = String(roundZoomUi(h0Zoom));
          if (inpFocusPx) inpFocusPx.value = '0';
          if (inpFocusPy) inpFocusPy.value = '0';
          syncTunerPoseOutputs();
          applyTunerPose();
        }

        function resetPosePreview() {
          if (inpRx) inpRx.value = String(poseResetRx);
          if (inpRy) inpRy.value = String(poseResetRy);
          if (inpRz) inpRz.value = String(poseResetRz);
          if (inpZoom) inpZoom.value = String(roundZoomUi(h0Zoom));
          if (inpFocusPx) inpFocusPx.value = '0';
          if (inpFocusPy) inpFocusPy.value = '0';
          syncTunerPoseOutputs();
          applyTunerPose();
        }

        if (presetFront) {
          presetFront.addEventListener(
            'click',
            () => applyPoseViewPreset(-90),
            { signal: acLoaded.signal }
          );
        }
        if (presetBack) {
          presetBack.addEventListener(
            'click',
            () => applyPoseViewPreset(90),
            { signal: acLoaded.signal }
          );
        }
        if (resetPoseBtn) {
          resetPoseBtn.addEventListener('click', () => resetPosePreview(), { signal: acLoaded.signal });
        }
      }

      function startScrollIntroAnimation() {
        if (!isWebglDesktopViewport()) return;
        if (scrollIntroDone || introScrollAnim || focusAnim || defocusAnim || !modelRoot) return;
        const q0 = modelRoot.quaternion.clone();
        introScrollAnim = {
          startTime: performance.now(),
          phase1Ms: SCROLL_INTRO_PHASE1_MS,
          phase2Ms: SCROLL_INTRO_PHASE2_MS,
          q0,
        };
        root.classList.add('custom-webgl__viewport--intro-anim');
        spinDeltaYaw = 0;
        spinDeltaTilt = 0;
      }

      function maybeStartScrollIntro() {
        if (disposed) return;
        if (!isWebglDesktopViewport()) return;
        if (scrollIntroDone || introScrollAnim || !enableScrollIntroAnimation) return;
        const w = root.clientWidth;
        const h = root.clientHeight;
        if (w < 2 || h < 2) return;
        const rect = root.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const visibleTop = Math.max(rect.top, 0);
        const visibleBottom = Math.min(rect.bottom, vh);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visibleRatio = visibleHeight / Math.max(1, rect.height);
        // Start only once at least half of the section is visible.
        if (visibleRatio >= 0.5) {
          startScrollIntroAnimation();
          return true;
        }
        return false;
      }

      function startHotspotFocus(sprite) {
        if (!sprite || !modelRoot) return;
        /** See `HOTSPOT_FOCUS_CONTROLS_MIN_DISTANCE` — avoids OrbitControls fighting the dolly. */
        controls.minDistance = HOTSPOT_FOCUS_CONTROLS_MIN_DISTANCE;
        const fromQuat = modelRoot.quaternion.clone();
        const fromCam = camera.position.clone();
        const fromTarget = controls.target.clone();
        const center = orbitTarget;
        const h = sprite.userData.hotspot;

        const vC = new THREE.Vector3().subVectors(camera.position, center);
        if (vC.lengthSq() < 1e-12) return;
        vC.normalize();

        let toQuat;
        if (h && h.useCustomRotation === true && Array.isArray(h.rotationDeg) && h.rotationDeg.length >= 3) {
          toQuat = quaternionFromHotspotRotationDeg(h.rotationDeg);
        } else {
          sprite.getWorldPosition(focusWorldScratch);
          const vH = new THREE.Vector3().subVectors(focusWorldScratch, center);
          if (vH.lengthSq() < 1e-12) return;
          vH.normalize();

          let qAlign;
          if (modelRotateAxisLock === 'y') {
            const vHXZ = new THREE.Vector3(vH.x, 0, vH.z);
            const vCXZ = new THREE.Vector3(vC.x, 0, vC.z);
            const lenH = vHXZ.length();
            const lenC = vCXZ.length();
            if (lenH < 1e-8 || lenC < 1e-8) {
              qAlign = new THREE.Quaternion().setFromUnitVectors(vH, vC);
            } else {
              vHXZ.multiplyScalar(1 / lenH);
              vCXZ.multiplyScalar(1 / lenC);
              const crossY = vHXZ.x * vCXZ.z - vHXZ.z * vCXZ.x;
              const dotXZ = vHXZ.x * vCXZ.x + vHXZ.z * vCXZ.z;
              const angle = Math.atan2(crossY, dotXZ);
              qAlign = new THREE.Quaternion().setFromAxisAngle(worldUpY, angle);
            }
          } else {
            qAlign = new THREE.Quaternion().setFromUnitVectors(vH, vC);
          }
          toQuat = fromQuat.clone().premultiply(qAlign);
        }

        /**
         * Match pose preview / “Copy rotation, pan & zoom”: same camera distance + direction as
         * `applyTunerPose` (orbit center + theme azimuth/elevation), not hotspot-radius dolly.
         */
        const fz = clampFocusZoom(h != null ? Number(h.focusZoomAlong) : NaN);
        const rawDist = fitDist * (fz / FOCUS_ZOOM_DIST_REF);
        const minDist = maxDim * TUNER_FOCUS_MIN_DIST_FACTOR;
        const dist = Math.max(rawDist, minDist);
        const cameraEnd = orbitTarget.clone().add(dirVec.clone().multiplyScalar(dist));
        const toTargetWorld = orbitTarget.clone();

        const fromPos = modelRoot.position.clone();
        const toPos = fromPos.clone();
        toPos.x = focusPanXWorldFromUnits(h?.focusPanX);
        toPos.y = modelYOffset + focusPanYWorldFromUnits(h?.focusPanY);

        focusAnim = {
          startTime: performance.now(),
          duration: HOTSPOT_FOCUS_DURATION_MS,
          sprite,
          fromQuat,
          toQuat,
          fromCam,
          toCam: cameraEnd,
          fromTarget,
          toTargetWorld,
          fromPos,
          toPos,
        };
        spinDeltaYaw = 0;
        spinDeltaTilt = 0;
        controls.enableDamping = false;
      }

      function openHotspotForSprite(sprite) {
        if (!sprite || introScrollAnim || defocusAnim) return;
        if (focusAnim && focusAnim.sprite === sprite) return;
        if (focusAnim) {
          focusAnim = null;
          controls.enableDamping = true;
        }
        const data = sprite.userData.hotspot;
        if (!data || !panel || !panelTitle || !panelBody) return;
        if (panel.hidden && sessionRestore === null) {
          sessionRestore = {
            quat: modelRoot.quaternion.clone(),
            cam: camera.position.clone(),
            target: controls.target.clone(),
            pos: modelRoot.position.clone(),
            minDistance: controls.minDistance,
          };
        }
        startHotspotFocus(sprite);
        panelTitle.textContent = data.title || '';
        panelBody.innerHTML = '';
        const text = data.body || '';
        const p = document.createElement('p');
        p.textContent = text;
        panelBody.appendChild(p);
        panel.hidden = false;
        setHotspotLabelActive(sprite);
        panelDismissOnNextPointerDown = true;
        activeHotspotSprite = sprite;
        root.classList.add('custom-webgl__viewport--hotspot-open');
      }

      let pointerDown = false;
      let dragMoved = false;
      let lastPx = 0;
      let lastPy = 0;

      /** While a panel is open, only the active hotspot is pickable (others are opacity 0). */
      function getHotspotPickTargets() {
        if (activeHotspotSprite != null && panel && !panel.hidden) {
          return [activeHotspotSprite];
        }
        return hotspotMeshes;
      }

      function tryHotspotPick(clientX, clientY) {
        if (introScrollAnim || defocusAnim || focusAnim) return;
        const rect = canvas.getBoundingClientRect();
        pointer.x = ((clientX - rect.left) / rect.width) * 2 - 1;
        pointer.y = -((clientY - rect.top) / rect.height) * 2 + 1;
        raycaster.setFromCamera(pointer, camera);
        const hits = raycaster.intersectObjects(getHotspotPickTargets(), false);
        for (const hit of hits) {
          if (hit.object.userData.hotspot) {
            if (
              activeHotspotSprite != null &&
              panel &&
              !panel.hidden &&
              hit.object === activeHotspotSprite
            ) {
              closePanel();
              return;
            }
            openHotspotForSprite(hit.object);
            break;
          }
        }
      }

      /** Raycast hotspots so the canvas shows `pointer` over sprites (mobile / canvas-only areas; desktop labels use CSS on `.custom-webgl__hotspot-label__hit`). */
      function syncWebglCanvasHoverCursor(clientX, clientY) {
        if (introScrollAnim || defocusAnim || focusAnim) {
          canvas.style.removeProperty('cursor');
          return;
        }
        if (!ENABLE_HOTSPOTS || hotspotMeshes.length === 0) {
          canvas.style.removeProperty('cursor');
          return;
        }
        const rect = canvas.getBoundingClientRect();
        if (
          clientX < rect.left ||
          clientX > rect.right ||
          clientY < rect.top ||
          clientY > rect.bottom
        ) {
          canvas.style.removeProperty('cursor');
          return;
        }
        pointer.x = ((clientX - rect.left) / rect.width) * 2 - 1;
        pointer.y = -((clientY - rect.top) / rect.height) * 2 + 1;
        raycaster.setFromCamera(pointer, camera);
        const hits = raycaster.intersectObjects(getHotspotPickTargets(), false);
        for (const hit of hits) {
          if (hit.object.userData.hotspot) {
            canvas.style.cursor = 'pointer';
            return;
          }
        }
        canvas.style.removeProperty('cursor');
      }

      for (const { sprite, el } of htmlLabelEntries) {
        el.addEventListener(
          'click',
          (e) => {
            if (activeHotspotSprite != null && panel && !panel.hidden) {
              e.preventDefault();
              e.stopPropagation();
              if (sprite === activeHotspotSprite) {
                closePanel();
              }
              return;
            }
            e.preventDefault();
            e.stopPropagation();
            openHotspotForSprite(sprite);
          },
          { signal: acLoaded.signal }
        );
      }

      stage.addEventListener(
        'pointerdown',
        (e) => {
          if (e.button !== 0) return;
          if (introScrollAnim) return;
          if (!panelDismissOnNextPointerDown || !panel || panel.hidden) return;
          if (panel.contains(e.target)) return;

          const labelEl =
            typeof e.target.closest === 'function'
              ? e.target.closest('.custom-webgl__hotspot-label')
              : null;
          if (labelEl && htmlLabelEntries.length > 0) {
            const entry = htmlLabelEntries.find(({ el }) => el === labelEl);
            if (entry && entry.sprite === activeHotspotSprite) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
          }

          panelDismissOnNextPointerDown = false;
          suppressNextCanvasHotspotPick = true;
          closePanel();
          document.addEventListener(
            'pointerup',
            () => {
              suppressNextCanvasHotspotPick = false;
            },
            { capture: true, once: true, signal: acLoaded.signal }
          );
          e.preventDefault();
          e.stopPropagation();
        },
        { capture: true, signal: acLoaded.signal }
      );

      function clearWebglDragState(e) {
        if (e && e.type === 'pointerup' && e.button !== 0) return;
        if (!pointerDown) return;
        pointerDown = false;
        dragMoved = false;
        canvas.classList.remove('custom-webgl__canvas--grabbing');
        if (e && e.pointerId != null) {
          try {
            canvas.releasePointerCapture(e.pointerId);
          } catch {
            /* ignore */
          }
        }
        if (e && Number.isFinite(e.clientX) && Number.isFinite(e.clientY)) {
          syncWebglCanvasHoverCursor(e.clientX, e.clientY);
        }
      }

      /** If pointerup misses the canvas (e.g. capture quirks), still end the drag. */
      function onDocumentPointerEnd(e) {
        if (e.button !== 0) return;
        clearWebglDragState(e);
      }

      document.addEventListener('pointerup', onDocumentPointerEnd, { signal: acLoaded.signal });
      document.addEventListener('pointercancel', onDocumentPointerEnd, { signal: acLoaded.signal });

      window.addEventListener(
        'blur',
        () => {
          if (!pointerDown) return;
          pointerDown = false;
          dragMoved = false;
          canvas.classList.remove('custom-webgl__canvas--grabbing');
        },
        { signal: acLoaded.signal }
      );

      canvas.addEventListener(
        'pointerdown',
        (e) => {
          if (introScrollAnim) return;
          if (e.button !== 0) return;
          pointerDown = true;
          dragMoved = false;
          lastPx = e.clientX;
          lastPy = e.clientY;
          canvas.classList.add('custom-webgl__canvas--grabbing');
          canvas.setPointerCapture(e.pointerId);
        },
        { signal: acLoaded.signal }
      );

      canvas.addEventListener(
        'pointermove',
        (e) => {
        if (introScrollAnim) return;
        if (!pointerDown) {
          syncWebglCanvasHoverCursor(e.clientX, e.clientY);
          return;
        }
        const dx = e.movementX != null ? e.movementX : e.clientX - lastPx;
        const dy = e.movementY != null ? e.movementY : e.clientY - lastPy;
        if (Math.abs(dx) + Math.abs(dy) > 2) dragMoved = true;
        lastPx = e.clientX;
        lastPy = e.clientY;
        if (!isWebglDesktopViewport()) return;

        const h = canvas.clientHeight || 1;
        const scale = (2 * Math.PI * ORBIT_ROTATE_SPEED) / h;
        if (modelRotateAxisLock !== 'tilt') {
          spinDeltaYaw -= scale * dx;
        }
        if (modelRotateAxisLock !== 'y') {
          spinDeltaTilt += scale * dy;
        }
        },
        { signal: acLoaded.signal }
      );

      canvas.addEventListener(
        'pointerleave',
        (e) => {
          if (pointerDown) return;
          canvas.style.removeProperty('cursor');
        },
        { signal: acLoaded.signal }
      );

      canvas.addEventListener(
        'pointerup',
        (e) => {
        if (introScrollAnim) return;
        if (e.button !== 0) return;
        if (suppressNextCanvasHotspotPick) {
          suppressNextCanvasHotspotPick = false;
          clearWebglDragState(e);
          return;
        }
        if (pointerDown && !dragMoved) {
          tryHotspotPick(e.clientX, e.clientY);
        }
        clearWebglDragState(e);
        },
        { signal: acLoaded.signal }
      );

      canvas.addEventListener(
        'pointercancel',
        (e) => {
          clearWebglDragState(e);
        },
        { signal: acLoaded.signal }
      );

      canvas.addEventListener(
        'lostpointercapture',
        (e) => {
          pointerDown = false;
          dragMoved = false;
          canvas.classList.remove('custom-webgl__canvas--grabbing');
          if (Number.isFinite(e.clientX) && Number.isFinite(e.clientY)) {
            syncWebglCanvasHoverCursor(e.clientX, e.clientY);
          }
        },
        { signal: acLoaded.signal }
      );

      closePanelImpl = () => {
        if (!panel) return;
        panelDismissOnNextPointerDown = false;
        activeHotspotSprite = null;
        root.classList.remove('custom-webgl__viewport--hotspot-open');
        panel.hidden = true;
        setHotspotLabelActive(null);
        if (sessionRestore) {
          if (focusAnim) focusAnim = null;
          const snap = sessionRestore;
          sessionRestore = null;
          defocusAnim = {
            startTime: performance.now(),
            duration: HOTSPOT_FOCUS_DURATION_MS,
            fromQuat: modelRoot.quaternion.clone(),
            toQuat: snap.quat.clone(),
            fromCam: camera.position.clone(),
            toCam: snap.cam.clone(),
            fromTarget: controls.target.clone(),
            toTarget: snap.target.clone(),
            fromPos: modelRoot.position.clone(),
            toPos: snap.pos.clone(),
            toMinDistance: snap.minDistance,
          };
          spinDeltaYaw = 0;
          spinDeltaTilt = 0;
          controls.enableDamping = false;
        }
      };

      if (enableScrollIntroAnimation && !prefersReducedMotion) {
        const scrollIntroObserver = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              const started = maybeStartScrollIntro();
              if (started || scrollIntroDone || introScrollAnim) {
                scrollIntroObserver.disconnect();
              }
              break;
            }
          },
          /** Wake when at least 50% of the section is visible. */
          { root: null, rootMargin: '0px', threshold: 0.5 }
        );
        scrollIntroObserver.observe(root);
        registerCleanup(() => scrollIntroObserver.disconnect());

        /** When layout/size is 0 on first paint (e.g. before aspect-ratio resolves), retry when the box gets dimensions. */
        const scrollIntroResizeObserver = new ResizeObserver(() => {
          maybeStartScrollIntro();
        });
        scrollIntroResizeObserver.observe(root);
        registerCleanup(() => scrollIntroResizeObserver.disconnect());

        /** IO / first layout can miss; double-rAF + delayed check catches already-visible sections. */
        let introRaf1 = 0;
        let introRaf2 = 0;
        introRaf1 = requestAnimationFrame(() => {
          introRaf2 = requestAnimationFrame(() => {
            maybeStartScrollIntro();
          });
        });
        const introScrollIntroT = setTimeout(() => {
          maybeStartScrollIntro();
        }, 0);
        registerCleanup(() => {
          cancelAnimationFrame(introRaf1);
          cancelAnimationFrame(introRaf2);
          clearTimeout(introScrollIntroT);
        });
      } else {
        scrollIntroDone = true;
      }

      function updateHotspotSpriteOpacities() {
        if (!ENABLE_HOTSPOTS || hotspotMeshes.length < 2) return;
        const active = activeHotspotSprite;
        const shouldDimOthers =
          active != null && panel && !panel.hidden;
        for (const sprite of hotspotMeshes) {
          const mat = sprite.material;
          if (!mat) continue;
          const target =
            shouldDimOthers && sprite !== active ? HOTSPOT_DIM_OPACITY : 1;
          const cur = mat.opacity;
          if (Math.abs(cur - target) < 0.002) {
            mat.opacity = target;
          } else {
            mat.opacity = cur + (target - cur) * HOTSPOT_OPACITY_LERP;
          }
        }
      }

      let rafId = 0;
      function animate() {
        if (disposed) return;
        rafId = requestAnimationFrame(animate);

        if (introScrollAnim) {
          const elapsed = performance.now() - introScrollAnim.startTime;
          const { phase1Ms, phase2Ms, q0 } = introScrollAnim;
          const total = phase1Ms + phase2Ms;
          if (elapsed < phase1Ms) {
            const linear = elapsed / phase1Ms;
            const t1 = easeInOutPow(linear, SCROLL_INTRO_PHASE1_EASE_POWER);
            const deg = -SCROLL_INTRO_NEG_DEG * t1;
            const qRot = new THREE.Quaternion().setFromAxisAngle(
              worldUpY,
              THREE.MathUtils.degToRad(deg)
            );
            modelRoot.quaternion.copy(qRot).multiply(q0);
          } else if (elapsed < total) {
            const linear = (elapsed - phase1Ms) / phase2Ms;
            const t2 = easeOutPow(linear, SCROLL_INTRO_PHASE2_EASE_OUT_POWER);
            const deg = -SCROLL_INTRO_NEG_DEG + SCROLL_INTRO_FWD_DEG * t2;
            const qRot = new THREE.Quaternion().setFromAxisAngle(
              worldUpY,
              THREE.MathUtils.degToRad(deg)
            );
            modelRoot.quaternion.copy(qRot).multiply(q0);
            const dot = Math.abs(modelRoot.quaternion.dot(q0));
            const angleRad =
              dot >= 1 - 1e-7 ? 0 : 2 * Math.acos(Math.min(1, dot));
            if (angleRad <= THREE.MathUtils.degToRad(SCROLL_INTRO_END_EPS_DEG)) {
              modelRoot.quaternion.copy(q0);
              introScrollAnim = null;
              scrollIntroDone = true;
              root.classList.remove('custom-webgl__viewport--intro-anim');
            }
          } else {
            modelRoot.quaternion.copy(q0);
            introScrollAnim = null;
            scrollIntroDone = true;
            root.classList.remove('custom-webgl__viewport--intro-anim');
          }
          modelRoot.updateMatrixWorld(true);
        } else if (defocusAnim) {
          const elapsed = performance.now() - defocusAnim.startTime;
          const t = Math.min(1, elapsed / defocusAnim.duration);
          const ease = smoothstep01(t);
          modelRoot.quaternion.slerpQuaternions(defocusAnim.fromQuat, defocusAnim.toQuat, ease);
          camera.position.lerpVectors(defocusAnim.fromCam, defocusAnim.toCam, ease);
          controls.target.lerpVectors(defocusAnim.fromTarget, defocusAnim.toTarget, ease);
          modelRoot.position.lerpVectors(defocusAnim.fromPos, defocusAnim.toPos, ease);
          modelRoot.updateMatrixWorld(true);
          if (t >= 1) {
            modelRoot.quaternion.copy(defocusAnim.toQuat);
            camera.position.copy(defocusAnim.toCam);
            controls.target.copy(defocusAnim.toTarget);
            modelRoot.position.copy(defocusAnim.toPos);
            controls.minDistance = defocusAnim.toMinDistance;
            defocusAnim = null;
            controls.enableDamping = true;
          }
        } else if (focusAnim) {
          const elapsed = performance.now() - focusAnim.startTime;
          const t = Math.min(1, elapsed / focusAnim.duration);
          const ease = smoothstep01(t);
          const tRot =
            t < HOTSPOT_FOCUS_ROT_DELAY
              ? 0
              : smoothstep01(
                  (t - HOTSPOT_FOCUS_ROT_DELAY) / Math.max(1e-6, 1 - HOTSPOT_FOCUS_ROT_DELAY)
                );
          modelRoot.quaternion.slerpQuaternions(focusAnim.fromQuat, focusAnim.toQuat, tRot);
          modelRoot.position.lerpVectors(focusAnim.fromPos, focusAnim.toPos, ease);
          modelRoot.updateMatrixWorld(true);
          controls.target.lerpVectors(focusAnim.fromTarget, focusAnim.toTargetWorld, ease);
          camera.position.lerpVectors(focusAnim.fromCam, focusAnim.toCam, ease);
          if (t >= 1) {
            modelRoot.quaternion.copy(focusAnim.toQuat);
            modelRoot.position.copy(focusAnim.toPos);
            camera.position.copy(focusAnim.toCam);
            controls.target.copy(focusAnim.toTargetWorld);
            camera.lookAt(orbitTarget);
            focusAnim = null;
            controls.enableDamping = true;
          }
        } else if (isWebglDesktopViewport()) {
          const up = new THREE.Vector3(0, 1, 0);
          const right = horizonAxisForView(camera, controls.target);
          if (modelRotateAxisLock === 'y') spinDeltaTilt = 0;
          if (modelRotateAxisLock === 'tilt') spinDeltaYaw = 0;
          let mag = Math.hypot(spinDeltaYaw, spinDeltaTilt);
          if (mag > MAX_SPIN_PER_FRAME && mag > 1e-12) {
            const s = MAX_SPIN_PER_FRAME / mag;
            spinDeltaYaw *= s;
            spinDeltaTilt *= s;
          }
          modelRoot.rotateOnWorldAxis(up, -spinDeltaYaw);
          modelRoot.rotateOnWorldAxis(right, -spinDeltaTilt);
          spinDeltaYaw *= 1 - SPIN_DAMPING_FACTOR;
          spinDeltaTilt *= 1 - SPIN_DAMPING_FACTOR;
          if (Math.abs(spinDeltaYaw) < 1e-7) spinDeltaYaw = 0;
          if (Math.abs(spinDeltaTilt) < 1e-7) spinDeltaTilt = 0;
        }

        controls.update();
        updateHotspotHtmlLabels();
        updateHotspotSpriteOpacities();
        for (const h of lightDebugHelpersWithUpdate) {
          if (h.visible) h.update();
        }
        renderer.render(scene, camera);
      }

      animate();
      registerCleanup(() => cancelAnimationFrame(rafId));
    },
    (xhr) => {
      updateLoadingProgress(xhr);
    },
    (err) => {
      try {
        dracoLoader.dispose();
      } catch {
        /* ignore */
      }
      hideLoading();
      if (typeof root.__webglDispose === 'function') {
        root.__webglDispose();
        root.__webglDispose = null;
      }
    }
  );
}

function boot() {
  const roots = document.querySelectorAll('[data-custom-webgl-root]');
  roots.forEach((root) => {
    initWebglRoot(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

/** Theme Editor re-renders sections when settings change; boot() only runs once, so re-init WebGL from updated JSON. */
document.addEventListener('shopify:section:load', (event) => {
  const container = event.target;
  if (!container || typeof container.querySelector !== 'function') return;
  const root = container.querySelector('[data-custom-webgl-root]');
  if (root) initWebglRoot(root);
});

document.addEventListener('shopify:section:unload', (event) => {
  const container = event.target;
  if (!container || typeof container.querySelector !== 'function') return;
  const root = container.querySelector('[data-custom-webgl-root]');
  if (root && typeof root.__webglDispose === 'function') {
    root.__webglDispose();
    root.__webglDispose = null;
  }
});
